import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface LegendarialAssessmentResult {
  id: string;
  assessmentType: string;
  scores: {
    overall: number;
    category1: number; // SWLS
    category2: number; // PIL
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const LegendarialAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as LegendarialAssessmentResult;
  
  // Debug: Log the received data
  
  if (!assessmentResult) {
    // If no result data, redirect to insights
    navigate('/panel/learn/');
    return null;
  }

  if (!assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/');
    return null;
  }

  try {
    // Determine which assessment was taken based on scores
    const isSWLS = assessmentResult.scores.category1 > 0 && assessmentResult.scores.category2 === 0;
    const isPIL = assessmentResult.scores.category2 > 0 && assessmentResult.scores.category1 === 0;
    
    const scoreLabel = isSWLS ? 'SWLS Score' : isPIL ? 'PIL Score' : 'Assessment Score';
    const assessmentName = isSWLS ? 'SWLS Assessment' : isPIL ? 'PIL Assessment' : 'Legendarial Assessment';
    
    const config = createAssessmentConfig(assessmentResult, {
      assessmentType: 'legendarial',
      assessmentName: 'legendarial-assessment',
      assessmentDisplayName: assessmentName.toUpperCase(),
      redoRoute: '/panel/learn/legendarial-assessment',
      completeRoute: '/panel/insights',
      scoreLabel: scoreLabel,
      subtitleMapping: {
        High: isSWLS ? 'Satisfied with Life' : isPIL ? 'High Sense of Purpose' : 'High Score',
        Moderate: isSWLS ? 'Moderate Life Satisfaction' : isPIL ? 'Moderate Sense of Purpose' : 'Moderate Score',
        Low: isSWLS ? 'Low Life Satisfaction' : isPIL ? 'Low Sense of Purpose' : 'Low Score'
      },
      visualMessage: "You've completed the assessment!",
      resultsTitle: isSWLS ? "Here's your life satisfaction analysis" : isPIL ? "Here's your purpose in life analysis" : "Here's your assessment analysis"
    });
    
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/');
    return null;
  }
};

export default LegendarialAssessmentCompletionPage;


